import { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { Button } from '../../../../../ui'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { useNavigate } from 'react-router-dom'
import api from '../../../../../helpers/apiRequester'
import Select from 'react-select'
import { ProgressView } from '../progressView'
import { foaSelect, yesNo } from '../../../../../data'
import { selectObjectProps } from '../../../../../interfaces'
import { Line } from 'react-chartjs-2'

export interface statsProps {
    data: any
}

export const MilestonesView = (props: statsProps) => {
    const navigate = useNavigate()
    const { data } = props
    const [showStats, setShowStats] = useState(false)
    const [editing, setEditing] = useState(false)
    const [caseData, setCaseData] = useState(data)
    const [dataChanged, setDataChanged] = useState(false)

    useEffect(() => {
        // console.log("DATAVIEW : ", data);
        setCaseData(data)

        if (!showStats && data && data.length > 0) {
            // console.log("DATA AVAILABLE....", data);
            setShowStats(true)
        }
    }, [data])

    useEffect(() => {
        // console.log("DATAVIEW : ", data);
        setCaseData(data)

        if (!showStats && data && data.length > 0) {
            // console.log("DATA AVAILABLE....", data);
            setShowStats(true)
        }
    }, [data])

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
    }

    const onChange = async (e: React.FormEvent<HTMLInputElement>) => {
        let tempCaseData = { ...caseData }
        tempCaseData[e.currentTarget.name] = e.currentTarget.value
        setCaseData(tempCaseData)
        setDataChanged(true)
    }

    const saveData = async () => {
        setEditing(false)
        console.log('SAVE DATA......')
        Loading.circle('Saving....')
        try {
            const apiResult = await api({
                url: 'save-case-info',
                data: { caseDataToSave: caseData },
            })
            Loading.remove()
            if (!apiResult.data.success) {
                return Report.failure('Error', 'An error occurred.', 'Okay')
            }
            return Report.success('Success', 'Your update was saved successfully.', 'Okay')
        } catch (error: any) {
            Loading.remove()
            Report.failure('Error', `${error.message}. Please refresh the page and try again.`, 'Okay')
        }
    }

    const handleEditToggle = () => {
        if (editing) {
            setCaseData(data)
        }
        setEditing(!editing)
    }

    const onSelectChange = (option: selectObjectProps | null, label: string) => {
        console.log('input label: ', label)
        if (option != null) {
            console.log('INPUT SELECT FIELD CHANGED...', option.value)

            const field = label
            const fieldValue = option.value
            let valueToSave

            if (field == 'cancelled' || field == 'poc_n1_v2_signed' || field == 'poc_issued') {
                valueToSave = fieldValue == 'Yes' ? 1 : 0
            }
            if (
                field == 'welcome_letter' ||
                field == 'lba' ||
                field == 'post_lba_update' ||
                field == 'lba_foa_response' ||
                field == 'poc_n1_v2_sent' ||
                field == 'EX160_sent'
            ) {
                valueToSave = fieldValue == 'Yes' ? 'sent' : 'not sent'
            }

            if (field == 'poc_n1_v2_signed' || field == 'EX160_signed') {
                valueToSave = fieldValue == 'Yes' ? 'YES' : 'NO'
            }

            if (field == 'foa') {
                valueToSave = fieldValue
            }

            if (field == '' || valueToSave == null) {
                console.log('value or field missing...', field)
                console.log('value or field missing...', valueToSave)
                return console.log('value or field missing...')
            }

            let tempCaseData = { ...caseData }
            tempCaseData[field] = valueToSave
            console.log('data to save : ', tempCaseData)

            setCaseData(tempCaseData)
            setDataChanged(true)
        }
    }

    const checkValue = (field: string) => {
        const fieldValue = caseData[field]

        if (field == 'cancelled' || field == 'poc_issued') {
            const filterValue = fieldValue == 1 ? 'Yes' : 'No'
            return yesNo.filter((option) => option.label === filterValue)
        }
        if (
            field == 'welcome_letter' ||
            field == 'lba' ||
            field == 'post_lba_update' ||
            field == 'lba_foa_response' ||
            field == 'poc_n1_v2_sent' ||
            field == 'EX160_sent'
        ) {
            const filterValue = fieldValue == 'sent' ? 'Yes' : 'No'
            return yesNo.filter((option) => option.label === filterValue)
        }

        if (field == 'poc_n1_v2_signed' || field == 'EX160_signed') {
            const filterValue = fieldValue == 'YES' ? 'Yes' : 'No'
            return yesNo.filter((option) => option.label === filterValue)
        }

        if (field == 'foa') {
            return foaSelect.filter((option) => option.label === caseData['foa'])
        }
    }

    return (
        <div className={styles.detailsView}>
            <h4>
                <span>Progress</span>
                <span>
                    <Button size="sm" variant="neutral" onClick={() => handleEditToggle()}>{editing ? 'Cancel' : 'Edit'}</Button>
                    {editing && dataChanged ? (
                        <>
                            <Button size="sm" variant="primary" onClick={() => saveData()}>
                            Save
                        </Button>
                        </>
                    ) : (
                        <></>
                    )}
                </span>
            </h4>
            <div>
                <ProgressView data={data} />
            </div>
            <div className={styles.viewContainer}>
                <form onSubmit={(e) => handleSubmit(e)}>
                    <fieldset>
                        <label>CFA Signed</label>
                        <input
                            className={styles.textInput}
                            name={'cfa_signed'}
                            value={caseData.cfa_signed}
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <fieldset>
                        <label>CFA Signed Date</label>
                        <input
                            className={styles.textInput}
                            name={'cfa_signed_date'}
                            value={
                                caseData.cfa_signed_date
                                    ? new Date(caseData.cfa_signed_date).toLocaleDateString('en-GB')
                                    : 'Not signed'
                            }
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <fieldset>
                        <label>Contact Fusion - CFA Signed ID</label>
                        <input
                            className={styles.textInput}
                            name={'contact_fusion_cfa_signed'}
                            value={caseData.cf_notification_id_cfa_signed}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <hr style={{ width: '100%', marginLeft: 0, marginBottom: 20 }} />

                    <fieldset>
                        <label>Credit Report Link</label>
                        <input
                            className={styles.textInput}
                            name={'cf_notification_id_full_claim_transfer'}
                            value={caseData.cf_notification_id_full_claim_transfer}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>
                    <fieldset>
                        <label>Contact Fusion - Credit Report ID</label>
                        <input
                            className={styles.textInput}
                            name={'cf_notification_id_credit_report_sent'}
                            value={caseData.cf_notification_id_credit_report_sent}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <hr style={{ width: '100%', marginLeft: 0, marginBottom: 20 }} />

                    <fieldset>
                        <label>Cancelled</label>
                        <input
                            className={styles.textInput}
                            value={caseData.cancelled == 1 ? 'Yes' : 'No'}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <hr style={{ width: '100%', marginLeft: 0, marginBottom: 20 }} />

                    <fieldset>
                        <label>Last Updated</label>
                        <input
                            className={styles.textInput}
                            name={'updated_at'}
                            value={new Date(caseData.updated_at).toLocaleString()}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <fieldset>
                        <label>Created At</label>
                        <input
                            className={styles.textInput}
                            name={'created_at'}
                            value={new Date(caseData.created_at).toLocaleString()}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>
                </form>
            </div>
        </div>
    )
}
